import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";
import { Card, CardContent } from "@/components/ui/card";

const StrategiePage = () => {
  const navigate = useNavigate();
  
  const handleNavigateBack = () => {
    navigate(-1);
    setTimeout(() => {
      const section = document.getElementById('ns3');
      if (section) {
        const offset = -80;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: images } = useQuery({
    queryKey: ["images", "strategie"],
    queryFn: async () => {
      console.log("Fetching images for strategie section");
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "strategie")
        .order('created_at', { ascending: true });
      
      if (error) throw error;
      console.log("Retrieved images:", data);
      return data;
    },
  });

  const getImageUrl = (index: number) => {
    if (images && images[index]) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[index].storage_path);
      return data.publicUrl;
    }
    return 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?auto=format&fit=crop&q=80';
  };

  const experiences = [
    {
      title: "NAMHAFTE GLOBALE KLIENTEN",
      content: "Beratung von drei DAX-30 Unternehmen, einigen KMUs, sowie mehreren Start-Ups u.a. in Deutschland, USA, Schweden, Portugal.",
      borderColor: "border-[#D3E4FD]"
    },
    {
      title: "PROBLEMSTRUKTURIERUNG",
      content: "Klare Strukturierung des Problems und Zerlegen in Einzelprobleme zur Findung der Grundproblems.",
      borderColor: "border-[#F2FCE2]"
    },
    {
      title: "ABLEITUNG HANDLUNGSEMPFEHLUNGEN",
      content: "Strategieberatung bedeutet Ableitung von messerscharfen Handlungsempfehlungen unter Berücksichtigung aller Vor- und Nachteile aller möglichen Lösungsoptionen nach einer eingehenden Analyse.",
      borderColor: "border-[#E2E5FD]"
    },
    {
      title: "NÜCHTERNE ANALYSE",
      content: "Die Analyse findet nüchtern und strukturiert auf Basis von Zahlen und Fakten statt.",
      borderColor: "border-[#E8D3FD]"
    },
    {
      title: "KREATIVE WORKSHOPS",
      content: "Oft werden Problemstrukturierung und Erarbeitung von Lösungsoptionen durch (kreative) Workshops mit dem Klienten begleitet, z.B. Design Thinking, Wold Café, Lego Serious Play.",
      borderColor: "border-[#FFDEE2]"
    },
    {
      title: "IMPLEMENTIERUNG",
      content: "Nach der Strategieentwicklung unterstütze ich bei der konkreten Umsetzung. Ich entwickle detaillierte Implementierungspläne und treibe durch professionelles Projektmanagement die erfolgreiche Umsetzung in der Organisation voran.",
      borderColor: "border-[#FDE1D3]"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#243949] to-[#517fa4]">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-lg md:text-xl font-bold text-white text-center uppercase flex-grow">
            Analytische Strukturierung
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="aspect-[21/9] w-full mb-8">
            <img
              src={getImageUrl(0)}
              alt="Strategie Bild"
              className="rounded-lg object-cover w-full h-full border border-[#9F9EA1]"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            {experiences.map((experience, index) => (
              <Card 
                key={index}
                className="bg-white/10 backdrop-blur-sm border-2 hover:border-white/40 transition-all duration-300"
              >
                <CardContent className="p-6">
                  <h3 className="text-base font-semibold text-white mb-3 uppercase text-center">
                    {experience.title}
                  </h3>
                  <p className="text-white/90 text-base leading-relaxed text-left">
                    {experience.content}
                  </p>
                </CardContent>
              </Card>
            ))}
          </div>

          <div className="flex justify-center mt-8">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-white/10 p-2 h-auto group"
              onClick={handleNavigateBack}
            >
              <div className="flex items-center animate-horizontal-bounce">
                <ChevronLeft className="w-4 h-4" />
                <ChevronLeft className="w-4 h-4 -ml-2" />
              </div>
              <span className="ml-2">Zurück</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StrategiePage;
